import { get } from 'svelte/store';
import { pop } from 'svelte-spa-router';

import { showNewsletterModal } from 'src/stores/ui/on-log-modals';
import { authLockedDeviceModal } from 'src/stores/device-runtime/firmware-ui';
import { includeDeviceModal } from 'src/stores/features/inclusion';
import { bulkActionEdit, edit, resetEditUpdateStore, update } from 'src/stores/ui/edit_lists';
import { force_go_back } from 'src/services/native_container_requests_android';
import { app, os } from 'src/stores/session/native-bridge';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
import { requestExitEditMode } from 'src/helpers/edit_chrome_helpers';
import { stopBluetoothScanner } from 'src/helpers/inclusion_helpers';

export const on_back: () => void = () => {
	const isSidePanelOpen = get(sidePanelStateCombined).open;
	// close drawer if open
	if (isSidePanelOpen) {
		setSidePanelState({ open: false });
		return;
	}

	// Exit list/room edit before routing (e.g. room → rooms list). A second
	// back press after edit is closed continues with normal navigation.
	if (get(edit)) {
		if (get(bulkActionEdit) || get(update).value) {
			resetEditUpdateStore();
		} else {
			void requestExitEditMode();
		}
		return;
	}

	// Android - use normal 'back button' behavior if the drawer is closed
	if (!isSidePanelOpen && get(app) && get(os) !== 'IOS') force_go_back(false);

	if (get(showNewsletterModal)) {
		showNewsletterModal.set(false);
		return;
	}

	if (get(authLockedDeviceModal)) {
		// string/undefined
		authLockedDeviceModal.set(undefined);
		return;
	}

	if (get(includeDeviceModal).show) {
		if (get(app)) {
			stopBluetoothScanner();
		}
		includeDeviceModal.update((state) => {
			return (state = { ...state, show: false });
		});
		return;
	}

	pop();
};
